import React, { useEffect, useRef } from "react";
// import Popup from "./Popup.js";
import markerGuess from "./../images/icons/marker_guess_small.png";
import markerAnswer from "./../images/icons/marker_answer_small.png";
// Variables
const GOOGLE_MAP_API_KEY = "AIzaSyBIBtBpZjoabkVow09Y2pxf9KD9_-b07E4";
const mapStyles = {
  width: "100%",
  height: "100%",
};

let hasResultBeenShown = false;
let areAllMarkersShown = false;
let distancePath = null;
let actualRound = 0;
let actualPosMarkers = [];
let guessPosMarkers = [];
let paths = [];
let geocoder;

function GoogleMaps(props) {
  // refs
  const googleMapRef = React.createRef();
  const googleMap = useRef(null);
  const marker = useRef(null);
  const infoWindow = useRef(null);
  let actualMarker = useRef(null);
  // helper functions
  // console.log('game isInline =', props.isInLine);

  let gestureHandling = props.isInLine ? "cooperative" : "greedy";
  // console.log("gesturehandling is", gestureHandling);

  const createGoogleMap = () =>
    new window.google.maps.Map(googleMapRef.current, {
      zoom: 2,
      center: {
        lat: props.lat,
        lng: props.lng,
      },
      backgroundColor: "white",
      zoomControl: true,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      rotateControl: false,
      gestureHandling: gestureHandling, // cooperative or greedy
      clickableIcons: false,
      fullscreenControl: false,
      styles: [
        {
          stylers: [
            {
              hue: "#007fff",
            },
            {
              saturation: 89,
            },
          ],
        },
        {
          featureType: "water",
          stylers: [
            {
              color: "#ffffff",
            },
          ],
        },
        // {
        //   featureType: "administrative.country",
        //   elementType: "labels",
        //   stylers: [
        //     {
        //       visibility: "off",
        //     },
        //   ],
        // },
      ],
    });

  const createMarker = () =>
    new window.google.maps.Marker({
      position: { lat: props.lat, lng: props.lng },
      map: googleMap.current,
      draggable: true,
      title: "Drag me!",
      icon: markerGuess,
    });

    
  const createActualLocationMarker = () =>
    new window.google.maps.Marker({
      position: {
        lat: props.actualPosition.lat,
        lng: props.actualPosition.lng,
      },
      map: googleMap.current,
      draggable: false,
      title: "Result",
      icon: markerAnswer,
    });

  const drawLineBetweenPoints = () => {
    //create a marker
    var guessMarker = new window.google.maps.Marker({
      position: marker.current.getPosition(),
      draggable: false,
      title: "Your Guess",
      icon: markerGuess,
    });
    guessPosMarkers.push(guessMarker);

    var distance = [props.actualPosition, marker.current.getPosition()];

    var lineSymbol = {
      path: "M 0,-1 0,1",
      strokeOpacity: 1,
      strokeColor: "#122F46",
      scale: 4,
    };
    distancePath = new window.google.maps.Polyline({
      path: distance,
      geodesic: true,
      strokeWeight: 1,
      strokeOpacity: 0,
      icons: [
        {
          icon: lineSymbol,
          offset: "0",
          repeat: "20px",
        },
      ],
    });
    marker.current.setDraggable(false);
    var bounds = new window.google.maps.LatLngBounds();
    distancePath.getPath().forEach(function (latLng) {
      bounds.extend(latLng);
    });
    googleMap.current.fitBounds(bounds);
    paths.push(distancePath);
    distancePath.setMap(googleMap.current);
    //disable the drag on the marker
  };

  function resetGuessMarker() {
    marker.current.setDraggable(true);
    const myLatLng = new window.google.maps.LatLng(0, 0);
    marker.current.setPosition(myLatLng);
    props.updateMarkerPos(0, 0);
    //reset the center of the map
    googleMap.current.setCenter(marker.current.getPosition());
    googleMap.current.setZoom(2);
  }

  function removeActualLocationMarker() {
    if (actualMarker) {
      if (actualMarker.current) {
        actualMarker.current.setMap(null);
        actualMarker.current = null;
        distancePath.setMap(null);
        distancePath = null;
      } 
    }
    
    //remove the marker from the map
    //remove the polyline from the map
  }

  function normalizeDistance(distance) {
    const max_distance = 19996;
    const score = map_range(distance, 0, max_distance, 100, 0);
    return Math.round(score);
    //based on this https://en.wikipedia.org/wiki/Extreme_points_of_Earth#:~:text=Farthest%2Dapart%20cities,-The%20pairs%20of&text=Rosario%2C%20Argentina%20to%20Xinghua%2C%20China,%3A%2019%2C989%20km%20(12%2C421%20mi)
  }

  function exponentiateScore(score) {
    const a = Math.log(score + 1) / 100;
    const y = Math.exp(a * score) - 1;
    return Math.round(y);
  }

  function map_range(value, low1, high1, low2, high2) {
    return low2 + ((high2 - low2) * (value - low1)) / (high1 - low1);
  }

  async function computeDistance(mk1, mk2) {
    var R = 6371.071; //Radius of the earth in KM
    var rlat1 = mk1.position.lat() * (Math.PI / 180); // Convert degrees to radians
    var rlat2 = mk2.position.lat() * (Math.PI / 180); // Convert degrees to radians
    var difflat = rlat2 - rlat1; // Radian difference (latitudes)
    var difflon = (mk2.position.lng() - mk1.position.lng()) * (Math.PI / 180); // Radian difference (longitudes)

    let d =
      2 *
      R *
      Math.asin(
        Math.sqrt(
          Math.sin(difflat / 2) * Math.sin(difflat / 2) +
            Math.cos(rlat1) *
              Math.cos(rlat2) *
              Math.sin(difflon / 2) *
              Math.sin(difflon / 2)
        )
      );
    const localities = props.gameData[props.round].location_props;
    if (localities.includes("country")) {
      let guessCC = ""
      const guessLocation = await getCountryCode(mk2);
      if(guessLocation){
        guessLocation.results.forEach((result) => {
          result.types.forEach((type) => {
            if (type === "country") {
              guessCC = result.address_components[0].short_name;
            }
          });
        });
      }else{
        guessCC = ""
      }
      
      const markerCC = props.gameData[props.round].country_code;

      // let markerCC = ""
      // const markerLocation = await getCountryCode(mk1);
      // if (markerLocation){
      //   markerLocation.results.forEach((result) => {
      //     result.types.forEach((type) => {
      //       if (type === "country") {
      //         markerCC = result.address_components[0].short_name;
      //       }
      //     });
      //   });
      // }
      // else{
      //   markerCC = ""
      // }

      if (markerCC === guessCC && markerCC !== "" && guessCC !== "") {
        d = 0;
      } 
    }
    return d;
  }

  async function getCountryCode(mk){
    const markerLat = mk.position.lat();
    const marketLng = mk.position.lng();
    const markerLatLng = new window.google.maps.LatLng(markerLat, marketLng);
    return geocoder.geocode({ location: markerLatLng }).then(
      function (results) {
        // console.log("geocode results", results);
        // console.log("getCountryCode, returning", results);
        return results;
      },
      function (error) {
        // console.log("getCountryCode, returning",error);
        // console.log(error);
        return null;
      }
    );
  }

  useEffect(()=>{
    areAllMarkersShown = false;
    hasResultBeenShown = false;
    areAllMarkersShown = false;
    distancePath = null;
    actualRound = 0;
    actualPosMarkers = [];
    guessPosMarkers = [];
    paths = [];
    if (!window.google) {
      initMap();
    } else {
      googleMap.current = createGoogleMap();
      marker.current = createMarker();
      window.google.maps.event.addListener(
        googleMap.current,
        "click",
        function (event) {
          if (marker.current.draggable) {
            marker.current.setPosition(event.latLng);
            const lat = event.latLng.lat().toFixed(3);
            const lng = event.latLng.lng().toFixed(3);
            props.updateMarkerPos(lat, lng);
          }
        }
      );
    }
  },[])

  useEffect(() => {
    if (props.round !== actualRound && hasResultBeenShown) {
      actualRound = props.round;
      hasResultBeenShown = false;
      resetGuessMarker();
      removeActualLocationMarker();
      return;
    }
    if (props.actualPosition && hasResultBeenShown === false) {
      async function getDistance(){
        hasResultBeenShown = true;
        actualMarker.current = createActualLocationMarker();
        actualPosMarkers.push(actualMarker.current);
        drawLineBetweenPoints();
        const distance = await computeDistance(actualMarker.current, marker.current);
        const normalizedScore = normalizeDistance(distance);
        const expScore = exponentiateScore(normalizedScore);
        props.displayResult(distance, expScore);
        return;
      }
      getDistance();
    }
    
    if (props.process === "end" && !areAllMarkersShown) {
      areAllMarkersShown = true;
      showGameData();
    }
  });

  const initMap = () => {
    const googleMapScript = document.createElement("script");
    googleMapScript.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAP_API_KEY}&libraries=places`;
    window.document.body.appendChild(googleMapScript);
    googleMapScript.addEventListener("load", () => {
      googleMap.current = createGoogleMap();
      props.registerMapsLoaded();
      marker.current = createMarker();
      marker.current.setAnimation(window.google.maps.Animation.BOUNCE);
      
      // Set the info window

      const contentString =
        '<div id="bodyContent" style="text-align:center; margin-bottom: 12px;margin-right: 12px; font-family:Google Sans;">' +
        props.i18n.move_pin+'<br>'+ props.i18n.to_guess +
        "</div>";


      infoWindow.current = new window.google.maps.InfoWindow({
        content: contentString,
        pixelOffset: new window.google.maps.Size(0, -24),
      });
      infoWindow.current.open({
      anchor: marker.current,
      map: googleMap.current,

      shouldFocus: false,
    });
      marker.current.addListener("click", stopBounce);
      geocoder = new window.google.maps.Geocoder();
      window.google.maps.event.addListener(
        marker.current,
        "dragend",
        function (evt) {
          const lat = evt.latLng.lat().toFixed(3);
          const lng = evt.latLng.lng().toFixed(3);
          props.updateMarkerPos(lat, lng);
        }
      );

      window.google.maps.event.addListener(
        marker.current,
        "dragstart",
        function (evt) {
          props.startDrag();
          stopBounce();
        }
      );

      window.google.maps.event.addListener(
        googleMap.current,
        "click",
        function (event) {
          if (marker.current.draggable) {
            if(marker.current.getAnimation() !== null) stopBounce();
            marker.current.setPosition(event.latLng);
            const lat = event.latLng.lat().toFixed(3);
            const lng = event.latLng.lng().toFixed(3);
            props.updateMarkerPos(lat, lng);
          }
        }
      );
    });
  };

  const stopBounce =() => {
    if(marker.current.getAnimation() !== null) marker.current.setAnimation(null);
    if(infoWindow.current)infoWindow.current.close();
  }

  const showGameData = () => {
    if(infoWindow.current) infoWindow.current.close();
    stopBounce();
    var bounds = new window.google.maps.LatLngBounds();
    for (let i = 0; i < paths.length; i++) {
      var marker = actualPosMarkers[i];
      var guessMarker = guessPosMarkers[i];
      var distancePath = paths[i];
      distancePath.getPath().forEach(function (latLng) {
        bounds.extend(latLng);
      });
      distancePath.setMap(googleMap.current);
      guessMarker.setMap(googleMap.current);
      marker.setMap(googleMap.current);
      let imageUrl = props.gameData[Object.keys(props.gameData)[i]].thumbnail +"=w150-h150-p";
      createCustomMarker(actualPosMarkers[i].getPosition(), imageUrl);
    }
    googleMap.current.fitBounds(bounds);
  };

  const createCustomMarker = (pos, url)=>{
    // POP UP CLASS
    class Popup extends window.google.maps.OverlayView {
      position;
      containerDiv;
      constructor(position /*, content*/, imgSrc) {
        super();
        //TODO: Create the content element dynamically
        const mapContainer = document.querySelector(".map-container");
        const content = document.createElement("div");
        content.id = "content";
        const image = document.createElement("img");
        content.appendChild(image);
        mapContainer.appendChild(content);

        this.position = position;
        content.classList.add("popup-bubble");
        this.containerImg = content.querySelector("img");
        this.containerImg.src = imgSrc;
        // This zero-height div is positioned at the bottom of the bubble.
        const bubbleAnchor = document.createElement("div");
        bubbleAnchor.classList.add("popup-bubble-anchor");
        bubbleAnchor.appendChild(content);
        // This zero-height div is positioned at the bottom of the tip.
        this.containerDiv = document.createElement("div");
        this.containerDiv.classList.add("popup-container");
        this.containerDiv.appendChild(bubbleAnchor);
        // Optionally stop clicks, etc., from bubbling up to the map.
        Popup.preventMapHitsAndGesturesFrom(this.containerDiv);
      }
      /** Called when the popup is added to the map. */
      onAdd() {
        this.getPanes().floatPane.appendChild(this.containerDiv);
      }
      /** Called when the popup is removed from the map. */
      onRemove() {
        if (this.containerDiv.parentElement) {
          this.containerDiv.parentElement.removeChild(this.containerDiv);
        }
      }
      /** Called each frame when the popup needs to draw itself. */
      draw() {
        const divPosition = this.getProjection().fromLatLngToDivPixel(
          this.position
        );
        // Hide the popup when it is far out of view.
        const display =
          Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000
            ? "block"
            : "none";

        if (display === "block") {
          this.containerDiv.style.left = divPosition.x + "px";
          this.containerDiv.style.top = divPosition.y + "px";
        }

        if (this.containerDiv.style.display !== display) {
          this.containerDiv.style.display = display;
        }
      }
    }

    // THE POPUP INSTANCE!
    const popup = new Popup(
      pos,
      //document.getElementById("content"),
      url
    );
    popup.setMap(googleMap.current);
  }

  return (
    <div className="map-container w-100 h-100">
      <div id="google-map" ref={googleMapRef} style={mapStyles} />
    </div>
  );
  
}


export default GoogleMaps;
